module.exports = __webpack_public_path__ + "static/media/10_FVCON_Is-Four.e14ff093.png";